export class Client {
    name: string
    website: string
    linkedin: string
    phone: string
    contactPerson:string
    salesperson: number
    id:number
    city_name:string
    state_name:string
    country_name:string
    salesperson_name:string
    poc_details:ClientPOC[]
    region:string
    created_at:string
    modified_at:string
    thumbnail:string
    address_field_1:string
    address_field_2:string
    zip_code:string
    created_by:number
    modified_by:number
    city:number
    state:number
    country:number
    country_code:number
    country_code_details:any
}

export class ClientPOC {
    client_name:string
    client_poc:number
    created_at:string
    created_by:number
    id:number
    modified_at:string
    modified_bynumber
    poc_email:string
    poc_linkedin:string
    poc_name:string
    poc_phone:string
    type:number
    type_name:string
}

export class ClientResponseModel {
    count:number
    next:string
    previous:string
    results: Client[]
    initialValue?:any
  }

export class City {
    id:number
    name:string
    state:number
}
export class State {
    id:number
    name:string
    country:number
}
export class Country {
    id:number
    name:string
    slug:string
}

export class CountryResponseModel {
    count:number
    next:string
    previous:string
    results: Country[] 
    initialValue?:any
}
export class StateResponseModel {
    count:number
    next:string
    previous:string
    results:  State[] 
    initialValue?:any
}
export class CityResponseModel {
    count:number
    next:string
    previous:string
    results: City[]
    initialValue?:any
}
export class ClientAddressType {
    id:number
    name:string
}

export class ClientAddressTypeResponseModel {
    count:number
    next:string
    previous:string
    results: Country[] 
}

export class ClientFilter{
    id:number
    name:string
    salesperson:number | number[]
    website:string
}


export class CountryCode {
    id:number
    country_name:string
    code:string
    country:number
}

export class CountryCodeResponseModel{
    count:number
    next:string
    previous:string
    results: CountryCode[]

}

export class ClientAddress {
    id:number
    address_field_1:string
    address_field_2:string
    zip_code:string
    address_type:number
    client_loc:number
    city:number
    state:number
    country:number
    created_by:number
    modified_by:number
    created_at:string
    modified_at:string
}